import * as React from 'react';

const HexLogo = ({ width = 128, height = 128 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="svg1"
    width={width}
    height={height}
    version="1.1"
    viewBox="0 0 33.867 38.741"
  >
    <g id="layer1" transform="translate(-91.546 -129.117)">
      <g
        id="g2"
        fill="#fff"
        stroke="#000"
        strokeDasharray="none"
        strokeDashoffset="0"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(44.593 -105.581)"
      >
        <path
          id="path33"
          strokeWidth="2.117"
          d="M260.882 330.486v18.256m-15.843-27.44 15.81 9.128m-31.685 0 15.81-9.128m-15.842 27.44v-18.256m15.842 27.44-15.81-9.128m31.685 0-15.81 9.128"
          transform="translate(-181.12 -85.545)"
        ></path>
        <path
          id="path1-7"
          strokeWidth="1.852"
          d="M245.007 330.486v18.256m7.937-18.256v18.256m-15.842-13.692 15.81 9.128m-11.842-16.002 15.81 9.128m-19.778 6.874 15.81-9.128m-19.78 2.254 15.811-9.128m-3.936 20.566v-18.256m-7.938 18.256v-18.256m15.843 13.692-15.81-9.128m11.841 16.002-15.81-9.128m19.779-6.874-15.81 9.128m19.779-2.254-15.81 9.128"
          transform="translate(-181.12 -85.545)"
        ></path>
      </g>
    </g>
  </svg>
);

export default HexLogo;
